module.exports = function ($scope) {

  var vm = this;

  function init() {
  }

  $scope.ok = function () {
    $scope.closeThisDialog({
      action: "ok",
      reason: vm.reason
    });
  }

  $scope.cancel = function () {
    $scope.closeThisDialog({ action: "cancel" });
  }

  init();
}
